

























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class DiagnosticsHelp extends Vue {
  tab = null;
}
